import { Link } from "react-router-dom";
import { useState } from "react";

export default function Header() {
  const [openDropdown, setOpenDropdown] = useState(false);

  const styles = {
    header: {
      background: "linear-gradient(135deg, #4A148C, #6A1B9A, #8E24AA)",
      padding: "20px 30px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      position: "relative",
      flexWrap: "wrap",
      boxShadow: "0 6px 20px rgba(0,0,0,0.35)",
      borderBottom: "3px solid #FFD700",
    },
    leftLogo: {
      display: "flex",
      alignItems: "center",
      gap: "15px",
    },
    logoImg: {
      width: "80px",
      height: "80px",
      objectFit: "contain",
      backgroundColor: "transparent",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
      transition: "transform 0.3s",
    },
    centerTitles: {
      textAlign: "center",
      flex: 1,
      color: "white",
      lineHeight: "1.4",
    },
    titleMain: {
      fontSize: "30px",
      fontWeight: "900",
      textShadow: "2px 2px 5px rgba(0,0,0,0.5)",
    },
    titleSub: {
      fontSize: "16px",
      fontWeight: "600",
      opacity: 0.85,
      marginTop: "4px",
    },
    rightPhotos: {
      display: "flex",
      alignItems: "center",
      gap: "15px",
    },
    photo: {
      width: "65px",
      height: "65px",
      borderRadius: "50%",
      objectFit: "cover",
      border: "3px solid white",
      boxShadow: "0 5px 15px rgba(0,0,0,0.4)",
      backgroundColor: "transparent",
      transition: "transform 0.3s",
    },
    nav: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      gap: "25px",
      marginTop: "15px",
      flexWrap: "wrap",
    },
    link: {
      color: "white",
      textDecoration: "none",
      fontSize: "18px",
      fontWeight: "700",
      letterSpacing: "0.5px",
      cursor: "pointer",
      position: "relative",
      padding: "5px 0",
      transition: "all 0.3s ease",
    },
    dropdownBox: {
      position: "absolute",
      top: "110%",
      left: "0",
      background: "#fff",
      color: "#333",
      borderRadius: "12px",
      boxShadow: "0px 8px 20px rgba(0,0,0,0.35)",
      width: "300px",
      padding: "12px 0",
      zIndex: 999,
      fontWeight: "600",
    },
    dropdownItem: {
      padding: "12px 20px",
      cursor: "pointer",
      color: "#333",
      fontSize: "16px",
      display: "block",
      transition: "0.3s",
    },

    /* =======================
        NEW MARQUEE CSS
       ======================= */
    marqueeWrapper: {
      width: "100%",
      background: "#26004d",
      padding: "10px 0",
      overflow: "hidden",
      whiteSpace: "nowrap",
      borderBottom: "3px solid #FFD700",
      boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
    },
    marqueeText: {
      display: "inline-block",
      fontSize: "20px",
      fontWeight: "800",
      background: "linear-gradient(90deg,#ffeb3b,#fff176,#ffeb3b)",
      WebkitBackgroundClip: "text",
      color: "transparent",
      paddingLeft: "100%",
      animation: "scroll-left 15s linear infinite",
      letterSpacing: "1px",
    }
  };

  // Inject Keyframes only once
  if (!document.getElementById("marquee-anim")) {
    const style = document.createElement("style");
    style.id = "marquee-anim";
    style.innerHTML = `
      @keyframes scroll-left {
        0% { transform: translateX(0%); }
        100% { transform: translateX(-100%); }
      }
    `;
    document.head.appendChild(style);
  }

  return (
    <>
      <header style={styles.header}>
        {/* LEFT LOGO */}
        <div style={styles.leftLogo}>
          <img
            src="/images/sj1.jpg"
            alt="Logo"
            style={styles.logoImg}
            onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
            onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
          />
        </div>

        {/* CENTER TITLE */}
        <div style={styles.centerTitles}>
          <div style={styles.titleMain}>पंचायत समिती बल्लारपूर</div>
          <div style={styles.titleSub}>जिल्हा चंद्रपूर, महाराष्ट्र - 442701</div>
        </div>

        {/* RIGHT PHOTO */}
        <div style={styles.rightPhotos}>
          <img
            src="/images/Seal_of_Maharashtra.png"
            alt="Seal"
            style={styles.photo}
            onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.15)")}
            onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
          />
        </div>

        {/* NAVIGATION */}
        <nav style={styles.nav}>
          <Link style={styles.link} to="/">मुख्य पृष्ठ</Link>
          <Link style={styles.link} to="/about">आमच्याबद्दल</Link>
          <Link style={styles.link} to="/departments">विभाग</Link>

          {/* DROPDOWN */}
          <div
            style={{ position: "relative", display: "inline-block" }}
            onMouseEnter={() => setOpenDropdown(true)}
            onMouseLeave={() => setOpenDropdown(false)}
          >
            <span style={styles.link}>योजना ⬇️</span>

            {openDropdown && (
              <div style={styles.dropdownBox}>
                <Link style={styles.dropdownItem} to="https://ladkibahinmaharashtra.com/">
                  मुख्यमंत्री माझी लाडकी बहीण
                </Link>
                <Link style={styles.dropdownItem} to="https://amritkaal.nic.in/meri-maati-mera-desh">
                  मेरी माटी मेरा देश अभियान
                </Link>
                <Link style={styles.dropdownItem} to="https://sjsa.maharashtra.gov.in/scheme/%E0%A4%AE%E0%A5%81%E0%A4%96%E0%A5%8D%E0%A4%AF%E0%A4%AE%E0%A4%82%E0%A4%A4%E0%A5%8D%E0%A4%B0%E0%A5%80-%E0%A4%B5%E0%A4%AF%E0%A5%8B%E0%A4%B6%E0%A5%8D%E0%A4%B0%E0%A5%80-%E0%A4%AF%E0%A5%8B%E0%A4%9C%E0%A4%A8/">
                  मुख्यमंत्री वृद्धाश्री योजना
                </Link>
                <Link style={styles.dropdownItem} to="https://sjsa.maharashtra.gov.in/scheme/%E0%A4%85%E0%A4%A8%E0%A5%81%E0%A4%B8%E0%A5%82%E0%A4%9A%E0%A4%BF%E0%A4%A4-%E0%A4%9C%E0%A4%BE%E0%A4%A4%E0%A5%80-%E0%A4%B5-%E0%A4%A8%E0%A4%B5%E0%A4%AC%E0%A5%8C%E0%A4%A7%E0%A5%8D%E0%A4%A6-%E0%A4%98-2/">
                  अनुसूचित जाती व जमाती वस्तीजविकास योजना
                </Link>
                <Link style={styles.dropdownItem} to="https://www.dord.gov.in/offerings/initiative/details/pm-janman-UDMwAjMtQWa">
                  PM JANMAN अभियान
                </Link>
                <Link style={styles.dropdownItem} to="https://pmaymis.gov.in/">
                  प्रधानमंत्री आवास योजना
                </Link>
                <Link style={styles.dropdownItem} to="https://mahayojanaa.com/shabari-awas-yojana-2025/">
                  शबरी आवास योजना
                </Link>
              </div>
            )}
          </div>

          <Link style={styles.link} to="/gallery">छायाचित्रे</Link>
          <Link style={styles.link} to="/officers">अधिकारी</Link>
          <Link style={styles.link} to="/ministers"> पदाधिकारी</Link>
          <Link style={styles.link} to="/contact">संपर्क</Link>
        </nav>
      </header>

      {/* ===========================
          NEW SCROLLING MARQUEE
      =========================== */}
      <div style={styles.marqueeWrapper}>
        <div style={styles.marqueeText}>
          पंचायत समिती बल्लारपूर | जिल्हा चंद्रपूर | महाराष्ट्र | पिनकोड : 442701
        </div>
      </div>
    </>
  );
}
